"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class CorporateBankAccount extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "CorporateBankAccount";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/corporate-bank-accounts"
    );
  }

  getApiPathForCreate() {
    console.error("Cannot create corporate bank accounts.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/corporate-bank-accounts/" +
      this.code
    );
  }

  getAdminPath() {
    console.error("Cannot go to a corporate bank account.");
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultTitle() {
    return this.displayName;
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default CorporateBankAccount;
